import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { INSURANCE_BUYING_FLOW_DETAILS_WIDTH } from 'common/constants/styles.constant';
import { useLocation } from 'react-router-dom';
import {
  AppRoutePath,
  InsuranceBuyingStepRoute,
} from 'common/enums/app-route-path.enum';

const styles = {
  root: {
    mt: 4,
    mb: 12,
  },
  stepperView: (fullWidth: boolean) => ({
    width: {
      xs: '100%',
      sm: '100%',
      md: fullWidth
        ? '100%'
        : `calc(100% - ${INSURANCE_BUYING_FLOW_DETAILS_WIDTH + 16}px)`,
    },
  }),
};

interface TravelBuyingWrapperProps {
  stepper: JSX.Element;
  outlet: JSX.Element;
}

function InsuranceBuyingRouteWrapper({
  stepper,
  outlet,
}: TravelBuyingWrapperProps) {
  const location = useLocation();

  return (
    <Container sx={styles.root}>
      <Box
        sx={styles.stepperView(
          location.pathname.includes(InsuranceBuyingStepRoute.PAYMENT_INFO) ||
            location.pathname.includes(AppRoutePath.HEALTH_AHHA)
        )}
      >
        {stepper}
      </Box>
      <Box mt={2}>{outlet}</Box>
    </Container>
  );
}

export default InsuranceBuyingRouteWrapper;
